import { createRef, PropsWithChildren, HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { useAdg4TabsContext } from "@/components/adg4/tabs/src/tabs.tsx";

import { Adg4TabFC } from "./tab-helper";

export type Adg4TabListProps = PropsWithChildren<{
    className?: string;
    rowGap?: string;
}> &
    HTMLAttributes<HTMLUListElement>;

const Adg4TabList: Adg4TabFC<Adg4TabListProps> = ({
    className,
    children,
    rowGap = "16px"
}: Adg4TabListProps) => {
    const containerRef = createRef<HTMLUListElement>();
    const { onKeyDown } = useAdg4TabsContext();

    const propsStyles = css({
        gap: rowGap
    });

    return (
        <ul
            ref={containerRef}
            css={[tabsContainerStyles, propsStyles]}
            onKeyDown={onKeyDown}
            className={className}
            tabIndex={-1}
            // Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role="tablist"
        >
            {children}
        </ul>
    );
};

const tabsContainerStyles = css({
    display: "flex",
    padding: 0,
    margin: 0,
    listStyle: "none",
    flexWrap: "wrap",
    justifyContent: "center"
});

Adg4TabList.tabsRole = "Adg4TabList";

export { Adg4TabList };
